<div id="documentclassesdiv" #documentclassesdiv class="document-classes" [style.height.px]="height"></div>